import configDefault from "./config-default";

const config = {
	...configDefault,
	code: 'genae.fr',
	appClassName: 'GENAE',
	favicon: '/genae-favicon.png',
	title: "Je m'inscris | GENAE",
	htmlCustomCSS: "genae.scss",
	companyName: "Genae Fitness Club",
	website: 'https://www.genaeclub.com/',
	notifyChannel: 'vel-genae',
	header: {
		title: null, //"Je m'abonne",
		logo: "/genae-logo--colored.png"
	},
	footer: {
		logo: "/genae-logo--white.png",
		cgv: {
			link: 'https://www.genaeclub.com/bouc-bel-air/conditions-generales/',
			text: 'CGV'
		}
	},
	promoCode: {
    label: "Avez-vous un code promo ?",
    placeholder: "VOTRE CODE ICI",
    confirmLabel: "Appliquer",
    verifyingLabel: "En cours de vérification"
	},
	payByCard: "PAYLINE",
	choice: {
		...configDefault.choice,
		nameColor: '#ff6600',
		border: '#EFECEC',
		border_selected: 'lightgray',
		background: 'white',
		footerBg: '#EFECEC',
		footerBg_selected: '#f7f7f7',
		checkboxSelected: '#ff6600'
	},
	errorCode: {
		...configDefault.errorCode,
		"api.error.sale.contact-invalid-data":"Veuillez essayer avec une autre adresse mail ou contacter le club directement.",
		default: "Une erreur est survenue avec Resamania2",
	},
	sign : {
		...configDefault.sign,
	},
	payment: {
		...configDefault.payment,
		loadingLabel: "Vérification en cours",
		informationLabel: "Informations de paiement",
		resumeLabel: "Total à payer par CB: ",
		payLabel: "Payer ",
		errorLabel: "Nous avons un soucis avec votre paiment.",
		errorTitle: "Une erreur est survenue",
	},
	loadingDefault: "Chargement en cours",
	loadingSmsCodeCheck: 'Vérification du code',
	loadingSmsCodeSend: 'Envoi du SMS',
	loadingTextUserCreation: "Création de votre compte",
	loadingTextCartCreation: "Création de votre panier",
	loadingTextAddressCheck: "Vérification de votre adresse",
	loadingTextOffersLoad: "Chargement des offres",
	plans: {
		noPlanFoundTitle: "Aucune formule",
		noPlanFoundTexts : [
			"Nous n'avons trouvé aucune formule pour ce club,",
			"veuillez réessayer plus tard ou changer de club via l'étape 1"
		],
		useImg : 'withText',
		beforeUser: true,
		imageBaseURL: 'https://api.resamania.com',
		title: "JE CHOISIS MA FORMULE",
		splitCounterAbo: {
			subsText : ["En illimité", "Dès 39€"],
			passText: ['A la séance', "Dès 5,50€"]
		},
		incitation: "Je choisis ma formule",
		feesLabel : "Licence",
		nofeesLabel: 'Aucune licence',
		autoSubmit: false,
		nextLabel: "Suivant",
	},
	productsLoader : {
		errorTitle: "Une erreur est survenue avec Resamania2",
		errorText: 'Veuillez réessayer plus tard ou avec un autre club',
	},
	options: {
		title: "Choisissez vos options",
		nextLabel: "Suivant",
		useImg : false,
		imageBaseURL: 'https://api.resamania.com',
		message: "Un doute sur le choix de tes options ? Rien de grave, tu pourras avoir des infos ultérieurement directement à l’accueil de ton club.",
	},
	regulars : {
		title: "OPTIONS ET EQUIPEMENTS",
		useImg : 'only',
		imageBaseURL: 'https://api.resamania.com',
		message: "Commandez ici, votre article est à l’accueil.",
		nextLabel: "Suivant",
	},
	recap: {
		title: "Ma sélection",
		myOffer: "Ma formule",
		myCounter: "Mes options et équipements",
		nextLabel: "Je confirme",
		payByCardLabel: "Total à payer par carte",
		payBySepaLabel : "Total prélevé directement",
	},
	sepa : {
		title: "RIB - Paiement Mensuel",
		validateLabel : "J’accepte par la présente les prélèvements automatiques SEPA",
		explain: "Veuillez mettre votre RIB ci-dessous pour valider votre abonnement et signer votre mandat de prélèvement SEPA",
		ownerLabel: "Titulaire du compte",
		ibanLabel: "IBAN",
		bicLabel: "BIC",
		bankLabel: "Nom de la banque",
	},
	contract: {
		title: "Votre contrat",
		signLabel: "Signer le contrat",
	},
	confirmation: {
		welcomeLabel: "Bienvenue chez",
		text: "Votre adhésion a bien été prise en compte, vous recevrez un e-mail de confirmation sous peu.",
		backLabel: "Retour au site."
	},
	steps: {
		display: {
			showShortNames: true,
		},
		clubSelect: {
			noAddress: true,
			showMap: "Masquer la carte",
			hideMap: "Voir la carte",
			title: 'JE CHOISIS MON CLUB',
			nextLabel: "Suivant",
			withMap: false,
			searchable:false,
			sameLine: true,
			autoSelect: true,
			//showOnly: 3,
			// confirm: {
			// 	txt: "En cochant cette case, je confirme souhaiter m’inscrire au club sélectionné, comme étant mon club d’entrainement principal."
			// }
		},
		userForm: {
			...configDefault.steps.userForm,
			nextLabel: "Suivant",
			genderLabel: 'Civilité',
			gender_F: "Mme",
			gender_M: "M.",
			firstnameLabel: 'Prénom',
			lastnameLabel: "Nom",
			emailLabel: 'Adresse e-mail',
			phoneLabel: "Nº de téléphone portable",
			phoneExplain: "Utilisé pour la signature du contrat et du mandat SEPA",
			birthdateLabel: "Date de naissance",
			addressLabel: "Adresse",
			backLabel: "Retour",
			noClub: true,
			noGender: true,
			noAddress: false,
			noBirthdate: true,
			title: "MES COORDONNÉES",
			optins: {
				acceptLegal: {
					text: "J’ai lu et j'accepte les conditions générales de Genae Fitness Club",
					moreLabel: "En savoir plus (Prévoir une pièce d'identité)",
					step: 1,
					href: 'https://www.genaeclub.com/bouc-bel-air/conditions-generales/',
					required: true
				},
				acceptNewsletter: {
					text: "🤝 Je rejoins les membres du « Quoi de neuf Genae ? » : email pour rester motivé, profiter de bons plans et ne rien manquer des nouveautés de mon club.",
					subtext: "✨ Nos emails sont rares, utiles, et pensés pour booster votre expérience chez Genae.",
					step: 1,
				}
			},
		},
	},
	stepsLabels: {
		...configDefault.stepsLabels,
	},
	stepsShortLabels: {
		...configDefault.stepsShortLabels
	},
	rootProperties: {
		'primary': '#AE1D22',
		'primary--dark': 'darken(#AE1D22, 15)',
		'placeholder': '#999999',
		'border': '#3d3d3d',
	},
	htmlStyle: `
		html {
			font-weight: 400;
			font-family: 'Roboto';
		}
	`,
	theme: {
		primary: '#ff6600',
		stepsDisplay: {
			color: {
				main: '#252525',
				bgFilled: '#252525',
				textFilled: 'white',

				subText: '#252525',
			}
		},
		loader : {
			border: 'black',
			border2: '#ff6600'
		},
		fontFamily: "Montserrat, sans-serif",
		buttonPrimary: {
			color: '#ff6600',
			text: '#fff',
		},
		buttonOther: {
			color: 'black',
			text: '#fff',
		},
		buttonSecondary: {
			color: "black",
			text: '#fff'
		},
		stepHeader: {
			fontWeight: 800,
			fontSize: "1.25rem",
			textTransform: 'uppercase',
			paddingTop:'1rem'
		}
	}
};

export default config;
